<template>
    <button 
        @click="toggleModal()"
        class="flex items-center justify-center rounded-full fixed bg-costeaPrimary w-16 h-16 transition duration-300 ease-in-out hover:bg-costeaHover  right-6 bottom-10 z-30">
        <i class="ri-add-fill text-5xl m-2 text-white" ></i>
    </button>
</template>

<script>
export default {
    data(){
        return{
            modalAct : false,
            
        }
    },
    methods:{
        modalActive(){
            this.modalAct = false;
            this.modalAct === false ? this.modalAct = true : this.modalAct = false
            return this.modalAct
        },
        toggleModal(){
            this.$emit('showModal', this.modalActive())
        },
    }
}
</script>

<style>

</style>